var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ver_detalle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 30,
    height: 30,
    transform: "translate(754 700)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    transform: "translate(-754 -700)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    "data-name": "Group 1742",
    transform: "translate(761.943 707.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M.563,364.023a.78.78,0,0,1-.556-.636.739.739,0,0,1,.706-.843c.034,0,.069,0,.1,0H13.9a.746.746,0,0,1,.814.672.737.737,0,0,1-.47.765c-.031.013-.06.029-.09.043Z",
    transform: "translate(0 -350.035)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M90.3,8.518a.907.907,0,0,1,.1-.16q1.1-1.109,2.2-2.213a.743.743,0,0,1,1.137.957c-.041.048-.086.093-.13.138l-3.5,3.5a.761.761,0,0,1-1.235,0Q87.1,8.968,85.329,7.194a.744.744,0,1,1,1.026-1.075c.363.352.716.715,1.073,1.074L88.6,8.366c.04.04.082.078.157.148V8.279q0-3.7,0-7.4a.911.911,0,0,1,.153-.587.756.756,0,0,1,.785-.268.73.73,0,0,1,.531.614,2.349,2.349,0,0,1,.014.275q0,3.682,0,7.365v.2l.066.04",
    transform: "translate(-82.136 -0.001)",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadDocument);
export default __webpack_public_path__ + "static/media/icon_download_document.a181ed3504eac6d369eda0894030a5b6.svg";
export { ForwardRef as ReactComponent };